<template>
    <LayoutDefault>
        <div class="text-center empty d-flex flex-column w-75 m-auto">
            <h4 class="m-5">Access Denied</h4>
            <img src="static/img/undraw_access_denied.svg" />
            <slot />
        </div>
    </LayoutDefault>
</template>

<script>
    import LayoutDefault from "@/templates/LayoutDefault";
    export default {
        name: "Denied",
        components: {LayoutDefault}
    }
</script>

<style lang="scss" scoped>
    img {
        width: 45%;
        margin: auto;
        margin-bottom: 3rem;
    }
</style>